// components/Header.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import {useSelector} from "react-redux";
import {selectUser} from "@/features/auth/model/authSlice";

export const Footer: React.FC = () => {
    const user = useSelector(selectUser);

    return (
        <footer className="footer">
            <div className="footer__top footer-top">
                <div className="container">
                    <div className="footer-top__grid">
                        <div className="footer-top__col footer-top__col_nav">
                            <nav className="nav footer__nav footer-top__nav">
                                <ul id="menu-footer-top" className="nav__list">
                                    <li id="menu-item-131"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-2 current_page_item menu-item-131 nav__item">
                                        <Link to="/" className="nav__link footer__link">Главная</Link>
                                    </li>
                                    <li id="menu-item-134"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-134 nav__item">
                                        <Link to="/contacts" className="nav__link footer__link">Контакты</Link>
                                    </li>
                                    <li id="menu-item-132"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-132 nav__item">
                                        <Link to="/information-sources" className="nav__link footer__link">Информационные ресурсы</Link>
                                    </li>
                                    <li id="menu-item-135"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-135 nav__item">
                                        <Link to="/faq" className="nav__link footer__link">Вопросы и ответы</Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div className="footer-top__col footer-top__col_email">
                            <div className="footer__email footer-top__email">
                                <a className="footer__link footer__email-link"
                                   href="">info@bionmax.ru</a>
                            </div>
                        </div>
                        <div className="footer-top__col footer-top__col_subscribe">
                            {user ? (
                                <div className="footer__subscribe footer-top__subscribe">
                                    <Link to="/help" className="nav__link footer__link under">Тех поддержка</Link>
                                </div>
                                ) : (
                                <div className="header__account" style={{marginRight: '20px'}}>
                                    <Link to="/login" className="button">Войти</Link>
                                </div>
                            )}

                            <div className="app-buttons">
                                <a href=""
                                   className="app-button">
                                    <span>Открыть в телеграм</span>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9484_13795)">
                                            <path d="M8.41624 13.916L8.06142 19.0346C8.56907 19.0346 8.78893 18.811 9.05259 18.5424L11.4326 16.2095L16.3644 19.9137C17.2688 20.4307 17.9061 20.1585 18.1501 19.0603L21.3872 3.50263L21.3881 3.50171C21.675 2.13038 20.9046 1.59413 20.0234 1.93055L0.99543 9.4023C-0.303189 9.9193 -0.283526 10.6618 0.774674 10.9982L5.63936 12.5501L16.939 5.29838C17.4708 4.93721 17.9543 5.13705 17.5566 5.49821L8.41624 13.916Z" fill="white"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_9484_13795">
                                                <rect width="21.45" height="22" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </a>
                            </div>
                        </div>
                        <div className="footer-top__col footer-top__col_social-links">
                            <div className="social-links footer__social-links footer-top__social-links">
                                <a className="social-links__link" href="" target="_blank">
                                    <svg className="svg-icon">
                                        <use
                                            href="/img/sprite-icons.svg#telegram"></use>
                                    </svg>
                                </a>
                                <a className="social-links__link" href="" target="_blank">
                                    <svg className="svg-icon">
                                        <use
                                            href="/img/sprite-icons.svg#vk"></use>
                                    </svg>
                                </a>
                                <a className="social-links__link" href="" target="_blank">
                                    <svg className="svg-icon">
                                        <use
                                            href="/img/sprite-icons.svg#youtube"></use>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer__bottom footer-bottom">
                <div className="container">

                        <div className="footer-bottom__inner">
                            <nav className="nav footer__nav footer-bottom__nav">
                                <ul id="menu-footer-bottom" className="nav__list">
                                    <li id="menu-item-137"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-137 nav__item">
                                        <Link to="/privacy-policy" className="nav__link footer__link under">Политика конфиденциальности</Link>
                                    </li>
                                    <li id="menu-item-136"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-136 nav__item">
                                        <Link to="/contract-offer" className="nav__link footer__link under">Договор оферты</Link>
                                    </li>
                                    <li id="menu-item-138"
                                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-138 nav__item">
                                        <Link to="/privacy-policy" className="nav__link footer__link under">Политика в отношении обработки персональных данных</Link>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                        <div className="flex">
                            <div className="footerLeft">
                                <div className="footer-bottom__descr">
                                    <p>Пожалуйста, обратите внимание, что BIONMAX предоставляет рекомендации по здоровью на основе
                                        ваших
                                        данных и привычек, однако не заменяет консультацию и рекомендации врача. Перед принятием
                                        каких-либо
                                        медицинских решений или изменением образа жизни, рекомендуется проконсультироваться с
                                        медицинским
                                        специалистом.</p>
                                </div>
                            </div>
                            <div className="footerRight">
                                <div className="footer__copyright footer-bottom__copyright">©
                                    2025 ООО «Ваша Лаборатория»
                                </div>
                                <div className="footer__copyright footer-bottom__copyright">(BionMax). Все права защищены.</div>
                            </div>
                        </div>



                </div>

            </div>
        </footer>
    );
};